<template>
  <div id="KnowledgeList" v-loading="loading" class="">
    <el-form
      ref="query"
      :model="query"
      label-width="120px"
      style="width: 500px; transition: all 0.5s"
      v-show="isShowQuery"
    >
      <el-form-item label="类型：" prop="professionId">
        <el-select
          v-model="query.professionId"
          size="small"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in categoryList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="内容：" prop="uName">
        <el-input
          v-model="query.uName"
          size="small"
          clearable
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item style="text-align: right">
        <el-button type="primary" size="small" @click="resetQuery('query')"
          >清空</el-button
        >
        <el-button type="primary" size="small" @click="handleQuery"
          >确定</el-button
        >
        <el-button type="primary" size="small" @click="isShowQuery = false"
          >关闭</el-button
        >
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="start" align="middle">
      <el-col style="margin-left: 10px">
        <el-button size="small" type="primary" @click="addKnowledge"
          >新增</el-button
        >
        <el-button size="small" type="primary" @click="isShowQuery = true"
          >搜索</el-button
        >
        <el-button size="small" type="primary" @click="combine">合并</el-button>
        <el-button size="small" type="primary" @click="deleteList"
          >删除</el-button
        >
        <!-- <el-button size="small" type="primary" @click="inserExcel"
          >导入</el-button
        > -->
        <el-button size="small" type="primary" @click="courseTeachingInserExcel"
          >导入课程教学知识点</el-button
        >
        <el-button size="small" type="primary" @click="checkTestSyllabus"
          >查看考试大纲知识点</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="provincialExaminationSyllabusInserExcel"
          >导入省考试大纲知识点</el-button
        >
      </el-col>
    </el-row>
    <el-table
      ref="table"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @sort-change="sortChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <!--        <el-table-column width="50" type="index" label="序号"></el-table-column>-->
      <el-table-column prop="sort" width="80" label="序号" sortable="custom">
      </el-table-column>
      <el-table-column prop="id" label="id" v-if="false"></el-table-column>
      <el-table-column
        width="50"
        prop="institutionId"
        label="创建人id"
        v-if="false"
      ></el-table-column>
      <el-table-column prop="knowledgeName" label="知识点名称">
        <template #default="scope">
          <span @click="changeKnowled(scope.row.id)" style="cursor: pointer">{{
            scope.row.knowledgeName
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="knowledgeDescription" label="知识点描述">
        <template #default="scope">
          <span @click="changeKnowled(scope.row.id)" style="cursor: pointer">{{
            scope.row.knowledgeDescription
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="institutionName" label="维护单位">
        <template #default="scope">
          <span
            v-if="scope.row.institutionId == '-1'"
            @click="changeKnowled(scope.row.id)"
            style="cursor: pointer"
          >
            平台维护
          </span>
          <span
            v-else
            @click="changeKnowled(scope.row.id)"
            style="cursor: pointer"
            >{{ scope.row.institutionName }}</span
          >
        </template>
      </el-table-column>
      <el-table-column width="80" label="省考标识" align="center">
        <template slot-scope="scope">
          <el-checkbox
            v-model="scope.row.provincialExamination"
            disabled
            true-label="1"
            false-label="0"
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>

    <Knowledge-add
      v-if="addDialog"
      ref="KnowledgeAdd"
      :courseWareId="courseWareId"
      :courseName="courseName"
      @closeAddDialog="closeAddDialog"
    ></Knowledge-add>
    <Knowledge-merge
      v-if="mergeDialog"
      @closeMergeDialog="closeMergeDialog"
      ref="KnowledgeMerge"
    ></Knowledge-merge>
    <!-- <Knowledge-inser v-if="inserDialog" ref="KnowledgeInser"></Knowledge-inser> -->
    <KnowledgeCourseTeachingInser
      v-if="courseTeachingInserDialog"
      ref="courseTeachingInserDialog"
      :courseWareId="courseWareId"
      @closeCourseTeachingInserDialog="closeCourseTeachingInserDialog"
    ></KnowledgeCourseTeachingInser>
    <KnowledgeTestSyllabus
      v-if="testSyllabusDialog"
      ref="testSyllabusDialog"
      :courseName="courseName"
      :courseWareId="courseWareId"
      @knowledgeGetList="getList"
      @closeTestSyllabus="closeTestSyllabus"
    ></KnowledgeTestSyllabus>
    <KnowledgeProvincialExaminationSyllabusInser
      v-if="provincialExaminationSyllabusInserDialog"
      ref="provincialExaminationSyllabusInserDialog"
      :courseWareId="courseWareId"
      @closeProvincialExaminationSyllabusInserDialog="
        closeProvincialExaminationSyllabusInserDialog
      "
    ></KnowledgeProvincialExaminationSyllabusInser>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/courseware/checkCourseware'
import KnowledgeAdd from './Knowledge-add'
import KnowledgeMerge from './Knowledge-merge'
// import KnowledgeInser from './Knowledge-inser'
import KnowledgeCourseTeachingInser from './Knowledge-courseTeaching-inser'
import KnowledgeTestSyllabus from './Knowledge-testSyllabus'
import KnowledgeProvincialExaminationSyllabusInser from './Knowledge-provincialExaminationSyllabus-insert'
export default {
  name: 'KnowledgeList',
  components: {
    KnowledgeAdd,
    KnowledgeMerge,
    // KnowledgeInser,
    KnowledgeCourseTeachingInser,
    KnowledgeTestSyllabus,
    KnowledgeProvincialExaminationSyllabusInser,
  },
  props: ['courseName', 'userType', 'courseWareId'],
  data() {
    return {
      addDialog: false,
      mergeDialog: false,
      // inserDialog: false,
      courseTeachingInserDialog: false,
      testSyllabusDialog: false,
      provincialExaminationSyllabusInserDialog: false,
      loading: false,
      reviewStatus: '2',
      reviewStatusList: [
        { value: '2', label: '待审核' },
        { value: '1', label: '审核通过' },
        { value: '0', label: '审核未通过' },
      ],
      isShowQuery: false,
      // 知识点类型
      categoryList: ['知识点名称', '知识点描述'],
      query: {
        professionId: '',
        uName: '',
      },
      tableData: [],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      // 选中的数组
      selectedList: [],
      isShowDialog: false,
      isShowDialogNotPass: false,
      dialogArr: [],
      knowledgeName: '',
      knowledgeDescription: '',
      orderBy: '',
    }
  },
  methods: {
    addKnowledge() {
      this.addDialog = true
      this.$nextTick(() => {
        this.$refs.KnowledgeAdd.init()
      })
    },

    // 修改编辑
    changeKnowled(id) {
      this.addDialog = true
      this.$nextTick(() => {
        this.$refs.KnowledgeAdd.init(id)
      })
    },
    closeAddDialog() {
      this.getList()
      this.addDialog = false
    },

    combine() {
      const selectedList = this.selectedList
      if (selectedList.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请先选择需要操作的数据',
        })
      } else if (selectedList.length < 2) {
        return this.$message({
          type: 'warning',
          message: '请先选择至少两条数据',
        })
      } else {
        let ids = ''
        for (let i = 0; i < selectedList.length; i++) {
          ids += selectedList[i].id + ','
        }
        this.mergeDialog = true
        this.$nextTick(() => {
          this.$refs.KnowledgeMerge.init(ids)
        })
      }
    },
    closeMergeDialog() {
      this.getList()
      this.mergeDialog = false
    },
    deleteList() {
      let isRoot = true
      const selectedList = this.selectedList
      if (selectedList.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请先选择需要操作的数据',
        })
      }
      selectedList.forEach((item) => {
        if (item.provincialExamination === '1') {
          if (this.userType !== '1') {
            isRoot = false
          }
        }
      })
      if (!isRoot) return this.$message.error('无权限删除省考标识知识点')
      confirmMsg(
        '删除此知识点会导致关联的课件没有知识点，此操作不可逆，是否删除？',
        async () => {
          let ids = ''
          for (let i = 0; i < selectedList.length; i++) {
            ids += selectedList[i].id + ','
          }
          api.updateStatus(ids).then(({ data }) => {
            if (data.code === 100000) {
              this.$message.success(data.msg)
              this.getList()
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      )
    },
    // 获取数据
    getList() {
      this.loading = true
      const { page, pageSize } = this.pageObj
      api
        .knowledgeGetList({
          page,
          pageSize,
          knowledgeName: this.knowledgeName,
          knowledgeDescription: this.knowledgeDescription,
          courseWareId: this.courseWareId || this.$route.query.id,
          orderBy: this.orderBy,
        })
        .then(({ data }) => {
          if (data.code === 100000) {
            this.tableData = data.data.list
            this.total = data.data.total
            this.loading = false
          } else {
            this.loading = false
            this.$message.error(data.msg)
          }
        })
        .catch((err) => {
          this.loading = false
          this.$message.error(err)
        })
    },

    // 获取专业
    getCategoryList() {
      // api.getAllCategory().then(({ data }) => {
      //   this.categoryList = data.data
      // })
    },

    // 导出通过
    // inserExcel() {
    //   this.inserDialog = true
    //   this.$nextTick(() => {
    //     this.$refs.KnowledgeInser.init()
    //   })
    // },

    // 导入课程教学知识点
    courseTeachingInserExcel() {
      this.courseTeachingInserDialog = true
      this.$nextTick(() => {
        this.$refs.courseTeachingInserDialog.init()
      })
    },
    closeCourseTeachingInserDialog() {
      this.getList()
      this.courseTeachingInserDialog = false
    },
    // 查看考试大纲知识点
    checkTestSyllabus() {
      this.testSyllabusDialog = true
      this.$nextTick(() => {
        this.$refs.testSyllabusDialog.init()
      })
    },
    closeTestSyllabus() {
      this.getList()
      this.testSyllabusDialog = false
    },
    // 导入省考试大纲知识点
    provincialExaminationSyllabusInserExcel() {
      //给老师导入省考试大纲,暂时开放
      // if (this.userType !== '1') {
      //   return this.$message.error('无权限导入省考试大纲知识点')
      // } else {
      this.provincialExaminationSyllabusInserDialog = true
      this.$nextTick(() => {
        this.$refs.provincialExaminationSyllabusInserDialog.init()
      })
      // }
    },
    closeProvincialExaminationSyllabusInserDialog() {
      this.getList()
      this.provincialExaminationSyllabusInserDialog = false
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },
    //序号排序
    sortChange({ order }) {
      if (order === 'descending') {
        this.orderBy = 'desc'
      } else {
        this.orderBy = 'asc'
      }
      this.getList()
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getList()
    },

    // 查询
    handleQuery() {
      if (this.query.professionId == '知识点名称') {
        this.knowledgeName = this.query.uName
      } else if (this.query.professionId == '知识点描述') {
        this.knowledgeDescription = this.query.uName
      } else {
        this.knowledgeName = ''
        this.knowledgeDescription = ''
      }
      this.pageObj.page = 1
      this.getList()
    },

    // 重置查询
    resetQuery(formName) {
      this.$refs[formName].resetFields()
      this.handleQuery()
    },
  },
  created() {
    // this.getCategoryList()
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
</style>
<style>
.el-notification__content {
  text-align: center;
}
</style>
